const cn = {
    lan_key: 'zh_CN',
    promotions: '推广',
    reserve: '预订',
    bookings: '订单',
    free_trans: '免费交通',
    my_booking: '我的订单',
    upcoming: '进行中',
    completed: '已完成',
    cancelled: '已取消',

    confirm: '确定',
    depart_date: '出发日期',
    depart_at: '出发时间',
    return_at: '返回时间',
    first_name: '名',
    last_name: '姓',
    contact_number: '联系电话',
    email: '邮箱',
    num_of_people: '旅客人数',
    room_num: '房间号',
    detail: '详情',
    booking_id: '预订ID',
    status: '状态',
    name: '姓名',
    hotel_name: '酒店名称',
    date: '日期',
    depart_time: '出发时间',
    return_time: '返回时间',
    license: '车牌号',
    driver_phone: '司机电话',

    to_be_confirm: '待确认',
    confirmed: '已确认',
    finished: '已完成',
    success_order: '预订成功',
    thank_booking: '感谢您的预订, 祝您旅途愉快',
    cancel_order: '取消订单',
    cancel_success: '您已成功取消订单',
    book_detail: '预订详情',
    passport_num: '护照号',
    period: '时间区间',
    cancel: '取消',
    back_to_home: '回到首页',

    wait_order_confirm: '订单确认中...',
    pls_wait_for: '请等待您的订单确认',

    tips1: '我们的工作人员将在出发前通过电话与您联系。请保持手机开机响铃。如果无法联系到您，司机可能不会接您。',
    tips2: '请随身携带所有乘客的护照。',
    tips3: '通过电子邮件获得订单确认。如果您未收到我们的电子邮件，请在“我的预订”中查看或在线与我们联系。',
    tips4: '请通过在线聊天或直接致电酒店前台联系我们（开放时间：09:00 - 18:00）。',
    tips5: '此优惠包括所有的免费交通服务。',
    tips6: '请提前10分钟等候在您的酒店大堂。',
    tips7: '服务热线：094-594-8895',

    sure_to_cancel_order: '确定要取消订单吗',
    cancel_fail_try_later: '取消失败，请稍后再试',

    pls_sel_depart_date: '请选择出发日期',
    pls_sel_depart_time: '请选择出发时间',
    pls_sel_return_time: '请选择返回时间',

    pls_input_first_name: '请输入名字',
    pls_input_last_name: '请输入姓氏',
    pls_input_contact_num: '请输入联系电话',
    pls_input_email: '请输入电子邮件',
    pls_input_room_num: '请输入房间号码',
    pls_input_people: '请输入乘客数量',

    c_sun: '日',
    c_mon: '一',
    c_tue: '二',
    c_wed: '三',
    c_thu: '四',
    c_fri: '五',
    c_sat: '六',

    wrong_msg: '错误的地址/电话号码/信息。',
    time_not_avail: '该时间不适合我。',
    change_excursion: '我改变了我的旅行。',
    change_mind: '我刚刚改变了主意。',
    other: '其他',
    pls_sel_a_cancel_reason: '请选择取消原因',
    sure_to_cancel_this_order: '确定取消订单吗',
    input_u_reason: '请说明您的原因（可选）',
    close: '关闭',

    product: '产品',
    destination: '目的地',
    hotel_address: '酒店地址',
    transport: '交通',

    view: '查看',
    servicer: '客服',
    wechat: '微信',
    play_guide: '游玩指引',
    pls_sel_product: '请选择产品',
    round_trip: '往返',
    no_need: '不需要',
    pls_input_hotel_name: '请输入酒店名称',
    pls_input_hotel_address: '请输入酒店地址',
    private_car: '专车',
    go_trip: '去程',
    return_trip: '回程',
    pls_scan_code_to_known: '请扫码添加客服，以便了解订单实时情况及产品信息',

    play_time: '游玩时间',

    if_need_traffic: '如需交通请联系客服',
    see_code_of_service: '查看客服二维码',
    service_email: '客服Email',

    more_info: '更多详情',
    customer_service: '服务中心',
    p_tips: '即日起，预订任意产品即可免费享受Marin Center的多项水上活动。',
    cancel_apply_submit_success: '取消申请提交成功',

    pls_sel_play_time: '请选择游玩时间',

    from_price_currency: '{currency}{price}起',
    pls_input_tel_no: '请输入手机号',
    no_pay_info: '没有支付相关信息',
    adult: '成人',
    children: '儿童',
    old_man: '老人',
    baby: '婴儿',
    package: '套餐',
    price: '价格',
    use_date: '使用日期',
    cer_no: '证件号',
    customer_info: '旅客信息',
    payment: '支付',
    quering_pay_status: '正在查询支付状态...',

    to_be_paid: '待支付',
    to_be_verify: '待核单',
    cancel_pending_confirm: '取消待确认',
    rejected: '已拒绝',
    fill_info: '填写资料',
    book_sel: '预订选择',
    trip_info: '出行信息',
    add_tourist: '新增游客',
    tourist: '游客',
    pls_input: '请输入',
    pls_input_name: '请输入姓名',
    pls_cer_no: '请输入证件号',
    contacts: '联系人',
    contact_tel: '联系手机',
    hotel_info: '酒店信息',
    total_amount: '总额',
    in_payment: '正在支付',
    to_pay: '去支付',
    num_of_copies: '份数',
    login: '登录',
    login_by_email: '邮箱登录',
    pls_input_email: '请输入邮箱',
    password: '密码',
    pls_input_pwd: '请输入密码',
    reg_user: '注册用户',
    third_party_login: '第三方登录',
    confirm_pwd: '确认密码',
    register: '注册',
    sel_pkg_date: '选择套餐·日期',
    sel_pkg: '选择套餐',
    sel_date: '选择日期',
    more: '更多',
    relate_itinerary: '相关行程',
    img_n_text: '图文详情',
    cost_desc: '费用说明',
    cost_include: '费用包含',
    cost_by_oneself: '费用自理',
    crow_desc: '人群说明',
    use_desc: '使用说明',
    notice_desc: '注意事项',
    cancel_rule: '退改规则',
    next_step: '下一步',
    refund_anytime: '随时可退',
    cant_refund: '不可退',
    years_old: '周岁',
    include: '含',
    not_include: '不含',
    over: '以上',
    under: '以下',
    birth_day: '生日',
    year: '年份',
    trip_date: '出行日期',
    book_date: '预订日期',
    meter: '米',
    unlimited: '不限',
    age_group: '年龄段',
    year_include: '周岁(含)',
    catering: '餐饮',
    shopping: '购物',
    traffic: '交通',
    gather: '集合',
    return_trip: '返程',
    play_act: '游玩活动',
    end_trip: '结束旅程',
    dining: '用餐',
    place: '地点',
    no_need_ticket: '无需门票',
    scenic_spots: '活动景点',
    free_time: '自由活动',
    disband_in_place: '就地散团',
    disperse_on_return_trip: '返程散团',
    send_on_return_trip: '返程送回',
    traffic_way: '交通方式',
    disband_place: '散团地点',
    gather_place: '集合地点',
    pickup_to: '上门接',
    biz_product: '营业产品',
    go_there: '前往',
    go_back: '返回',
    logout: '退出登录',
    sure_to_logout: '确定要退出吗',
    create_success_pls_pay: '订单创建成功,请完成支付',

    monday_w: '周一',
    tuesday_w: '周二',
    wednsday_w: '周三',
    thursday_w: '周四',
    friday_w: '周五',
    saturday_w: '周六',
    sunday_w: '周日',

    cul_age_standar: '按{ageType}计算年龄，以{dateType}实际年龄为准',
    can_n_book_lonely: '{man}不能单独购买',
    input_one_at_least: '至少填写一位客人信息',
    t_remark: '备注',
    pls_input_x_customer_info: '请填写{num}位客人信息',
    pls_sel_country: '请选择国家',
    birth_date: '出生日期',
    t_sex: '性别',
    cn_name: '中文姓名',
    en_name: '英文姓名',
    cn_en_name: '中/英文姓名',
    national_region: '国家/地区',
    t_height: '身高',
    t_male: '男',
    t_female: '女',
    pls_sel_date: '请选择日期',
    t_quality: '数量',
    t_pay_remain_time: '剩余支付时间: {minute}分 {second}秒',
    t_no_relate_trip_info: '没有相关行程信息',
    t_disclaimer: '免责条款',
    t_min_book: '{minBook}份起订',
    t_detail: '明细',
    t_fee_detail: '费用明细',
    t_see_trip_info: '查看行程详情',
    t_need_change_contact_service: '如需变更订单，请联系客服',

    t_surcharge: '附加费',
    t_pls_sel_buy_num: '请选择购买数量',
    t_loging: '正在登录',
    t_to_wx_auth: '正在微信授权',
    t_all: '全部',
    t_contact_service: '联系客服',

    t_send_email_tips: '确认单将通过邮件方式发送到对应的邮箱',
    t_clear_cache: '清除缓存',
    t_clear_success: '清除成功',
    t_sure_to_clear: '确定要清除缓存吗',
    t_no_stock: '无库存',
    t_refresh: '刷新',
    t_filter: '筛选',

    t_collapse_all: '收起全部',
    t_expand_all: '展开全部',
    t_bind_account: '绑定帐号',

    t_between_num: '{from}{unit}-{to}{unit}',
    t_age: '年龄',
    t_sel_time: '选择时间',
    t_unlimit_crowd: '不限人群',

    t_pending_payment: '待付款',
    t_unpaid: '未付款',
    t_paid: '已付款',
    t_refunded: '已退款',
    t_order_submitted: '已提交',
    t_await_confirm: '待确认',
    t_order_confirmed: '订单已确认',
    t_completed: '已完成',
    t_cancel_pending_confirm: '取消待确认',
    t_order_canceled: '订单已取消',

    t_notice_title: '公告：为了更好地查看订单信息，请使用预订时填写的邮箱登录账号。',
    t_notice_content: '如果当前页面未显示您的订单，请使用预订时填写的邮箱登录账号。初始密码已通过邮件发送至您的预留邮箱，请注意查收。',

    t_agree_1: '同意注册tour账号',
    t_agree_2: '同意上述声明',
    t_agree_3: '提交信息后不可更改',

    t_forget_pwd: '忘记密码',
    t_email_of_receive: '接收新密码的邮箱',
    t_reset_pwd_succes_tips:'新密码已送至邮箱，请查收',

    t_collapse: '收起',
    t_expand: '展开',

    what_is_included: '费用包含',
    what_is_not_included: '费用自理',

}

export default cn
